import React, { useEffect, useState } from "react";
import { Box, FormControl, TextField, FormLabel, Select, MenuItem, Typography, RadioGroup, FormControlLabel, Radio, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface PaceAIDeviceSectionProps {
  unitSettings: any;
  setUnitSettings: (settings: any) => void;
  selectDeviceIds: string[];
  value: string;
  setValue: (value: string) => void;
}

export default function PaceAIDeviceSection({ unitSettings, setUnitSettings, selectDeviceIds, value, setValue }: PaceAIDeviceSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [radioValue, setRadioValue] = useState(value);

  const handleRadioChange = (val: any) => {
    setRadioValue(val);
    setValue(val);
  };

  // console.log("unitSettings", unitSettings);

  const handleSerialNumberChange = (event: any) => {
    setUnitSettings((prev: any) => ({
      ...prev,
      pace_device_serial_number: event.target.value,
    }));
  };

  const toggleExpansion = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    console.log(value, "------------------");
  }, [value]);

  return (
    <Box sx={{ marginTop: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">PACE AI Device Connection</Typography>
        <IconButton onClick={toggleExpansion}>{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <FormControl fullWidth margin="dense" variant="outlined" sx={{ marginTop: 2 }}>
          <TextField
            value={unitSettings?.pace_device_serial_number || ""}
            label="PACE AI Device ID"
            variant="outlined"
            size="medium"
            onChange={(e) => handleSerialNumberChange(e)}
            slotProps={{ input: { readOnly: true } }}
          />
        </FormControl>

        <FormControl component="fieldset" sx={{ marginTop: "20px" }}>
          <Typography variant="h6" sx={{ textAlign: "left" }}>
            PACE AI Device Actions
          </Typography>
          <RadioGroup
            aria-label="pace-ai-device"
            name="pace-ai-device"
            value={radioValue}
            onChange={(event) => handleRadioChange(event.target.value)}
            sx={{
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <FormControlLabel value="take_online" control={<Radio disabled={unitSettings?.pace_device_serial_number ? false : true} />} label="Take online" />
            <FormControlLabel value="bypass" control={<Radio disabled={unitSettings?.pace_device_serial_number ? false : true} />} label="Bypass" />
            <FormControlLabel value="reboot" control={<Radio disabled={unitSettings?.pace_device_serial_number ? false : true} />} label="Reboot" />
          </RadioGroup>
        </FormControl>
      </Collapse>
    </Box>
  );
}
